<div class="ui-g page-header-c">
    <div class="ui-g-12 ui-md-6 ui-lg-6">
        <h1 class="page-title" translate><span class="backbtn" (click)="goBack()"><i
                    class="fa fa-arrow-left"></i></span>label_teams_details
        </h1>
    </div>
</div>
<div class="ui-g form-container containar-layout shift-planning-section">
    <div class="ui-g-12">
        <div class="ui-g pb-20">
            <div class="ui-g-12  ui-md-12 ui-lg-12 add-shift">
                <div class="ui-g add-shift">
                    <!--<div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_team</label>
                        </div>
                        <div class="form-control-c">
                            <input autocomplete="off"
                                oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.substr(1)"
                                [(ngModel)]="teamNamesa" type="text" [placeholder]="'label_team' | translate" disabled
                                pInputText />
                        </div>
                    </div>-->
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_name</label>
                        </div>
                        <input autocomplete="off" class="w-170" type="text" maxlength="30"
                        [placeholder]="'label_shift_planning_schedule' | translate"
                        [(ngModel)]="shiftSchedule" pInputText required />
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_on</label>
                        </div>
                        <div class="form-control-c">
                            <p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                [(ngModel)]="endDateTimeStr">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_start_date</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [defaultDate]="maxDate" [minDate]="minDate" dateFormat="{{dateFormat}}"
                                [showIcon]="true" [placeholder]="'label_shift_start_date' | translate"
                                [(ngModel)]="endDateTimeS" [disabled]="endDateTimeStr != 'custom'"
                                (click)="onStartDateClick(endDateTimeS)"  ></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_date</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [defaultDate]="maxDate" [minDate]="maxDate" dateFormat="{{dateFormat}}"
                                [showIcon]="true" [placeholder]="'label_shift_end_date' | translate" [minDate]="maxDate"
                                [(ngModel)]="endDateTimeSe" [disabled]="endDateTimeStr != 'custom'"></p-calendar>
                        </div>
                    </div>
                   
                    <!-- <div class="form-field ui-g-12 ui-md-3 ui-lg-3 switch-btn">
                        <div class="form-label">
                            <label for="providerName" translate>Delete</label>
                        </div>
                        <div class="form-control-c">
                            
                        </div>
                    </div> -->
                    <!--<div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_weekly_allocationp</label>
                        </div>
                        <div class="circle-checkbox nowrap">
                            <label *ngFor="let objCheckbox of daysList; let i=index">
                                <input type="checkbox" [(ngModel)]="weeklyAllocationData[i].isMandatory"
                                    name="chk{{ri}}" value="weeklyAllocationData[i].id"
                                    (change)="allocationListData(weeklyAllocationData)">
                                <span class="checkmark"><span class="chk-pos" translate>{{
                                        objCheckbox.displayValue }}</span></span>
                            </label>
                        </div>
                    </div>-->
                </div>

                <div class="ui-g add-shift">
                   
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_weekly_allocationp</label>
                        </div>
                        <div class="circle-checkbox nowrap">
                            <label *ngFor="let objCheckbox of daysList; let i=index">
                                <input type="checkbox" [(ngModel)]="weeklyAllocationData[i].isMandatory"
                                    name="chk{{ri}}" value="weeklyAllocationData[i].id"
                                    (change)="allocationListData(weeklyAllocationData)">
                                <span class="checkmark"><span class="chk-pos" translate>{{
                                        objCheckbox.displayValue }}</span></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_start_time</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12" [(ngModel)]="startTimeStr"
                                [placeholder]="'label_start_time' | translate" [defaultDate]="currentDate"
                                (onBlur)="getTime(startTimeStr)" required></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_time</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12" [(ngModel)]="endTimeStr"
                                [placeholder]="'label_end_time' | translate" [defaultDate]="currentDate"
                                (onBlur)="getEndTime(endTimeStr)" required></p-calendar>
                        </div>                        
                    </div>
                    <!--<div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_ends_on</label>
                        </div>
                        <div class="form-control-c">
                            <p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                [(ngModel)]="endDateTimeStr">
                            </p-dropdown>
                        </div>
                        <div *ngIf="endDateTimeStr === 'custom'">
                            <div class="form-label">
                                <label for="providerName" translate>label_date</label>
                            </div>
                            <div class="form-control-c">
                                <p-calendar [defaultDate]="maxDate" [minDate]="maxDate" dateFormat="{{dateFormat}}"
                                    [showIcon]="true" [placeholder]="'label_date' | translate"
                                    [(ngModel)]="endDateTimeS"></p-calendar>
                            </div>
                        </div>

                    </div>-->
                </div>
            </div>

        </div>
        <!--<div *ngIf="endDateTimeStr != 'custom'" class="bulk-warning">
            {{'label_bulk_warning' | translate:{maxDays:maxDays} }}
        </div>-->
    </div>
</div>
<div class="ui-g-12 shift-planning-section">
    <app-mi-grid-selection [url]="url" [columnDefs]="columns" [pagination]="false" [actionButtonsDefs]="buttons"
        actionWidth="150" selectionCheckbox="true" (checkboxClickedEvent)="checkboxClicked($event)"
        (allTasksEmitterEvent)="allTasksEvent($event)" [paginationPageSize]="100" [actionButtonsDefs]="buttons"
        rowSelection="multiple" [exportUrl]="exportUrl" (allTaskSelectedEvent)="selectAllData($event)"
        [printUrl]="printUrl" divClass="mi-grid" [placeholderValue]="'Search by Team Member'"></app-mi-grid-selection>
</div>
<div class="form-buttons ui-g-12 pt-20 mrg-top">
    <button class="cancel-btn" pButton type="button" [label]="'Cancel' | translate" (click)="cancelBut()"></button>
    <button class="save-btn" pButton type="button" [label]="'Save' | translate"
        (click)="onBulkScheduleSave(weeklyAllocationData)"
        [disabled]="!bulckScheduleChecked || !startTimeStr || !endTimeStr || !endDateTimeStr || ( endDateTimeStr === 'never' && !endDateTimeS)  || ( endDateTimeStr === 'custom' && !endDateTimeS) || endDateTimeStr === 'custom' && !endDateTimeSe || !isChecked"></button>
</div>
<!--<p-confirmDialog header="Confirmation" icon="fa fa-question-circle"></p-confirmDialog>-->

<p-dialog [blockScroll]="true" [header]="labelAddShift" modal="true" [showHeader]="true" styleClass="edit-profile-popup"
  [style]="{width: '500px'}" responsive="true" [(visible)]="showDialog"  (onHide)="onHideDialog()">
  <div class="ui-g form-container">   
 
   <div class="ui-g-12">
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <div class="dialog-text">
           <p>Would you like to override the existing shift schedule or adjust it?</p>
        </div>
        <div class="mt-20 dialog-text">
            <p> <span> Overriding </span> the shift will remove the existing shifts and the newly applicable shift will come in effect.</p>
        </div>
        <div class="mt-20 dialog-text">
            <p><span> Adjusting </span> the shift will either merge the shift if it is overlapping and if not, then system will maintain the existing shift and add the newly applicable shift.</p>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-g-nopad form-buttons">
        <div class="page-buttons mt-30">
            <button pButton type="button" [label]="labelOverride" 
                (click)="setOverrideValue()"></button>
        </div>
        <div class="adjust-btn mt-30">
            <button pButton type="button" [label]="labelAdjust" 
                (click)="setAdjustValue()"></button>
        </div>      
     
    </div>
  </div>
</p-dialog>